import { Popover } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { formatNumber } from '../../../FormatNumber';

export function PopoverHomeAmount({children, title, amount, record}) {
    const companyCurrencySymbol = useSelector(state => state.Auth.companyCurrencySymbol);

    // hide popover if same currency
    if (companyCurrencySymbol === record.currency_symbol)
        return <span>{children}</span>;

    // TODO: get width from table to determine popover overlay width
    return (
        <Popover
            title={title}
            content={amount !== null || amount !== undefined ? (
                <span className="popover-amount-td">
                    <span className="currency">
                        {companyCurrencySymbol}
                    </span>
                    <span className="value">
                        {formatNumber(amount, 2, undefined, true)}
                    </span>
                </span>
            ) : '-'}
            overlayStyle={{maxWidth: 150}}
            getPopupContainer={() => document.getElementById('bukkuContent')}
        >
            <span>{children}</span>
        </Popover>
    );
}
